var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdb-container',{staticClass:"bodyimg",attrs:{"fluid":""}},[_c('mdb-row',{staticClass:"bodyimgrow"},[_c('mdb-col',{staticClass:"bodycol"},[_c('img',{staticClass:"bodyimg",attrs:{"src":"/static/images/body/dontshade.png"}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }